export default function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="mb-6 md:mb-8 flex flex-col md:flex-row md:items-start md:justify-between gap-4 md:gap-6">
      <div className="min-w-0">
        {eyebrow && (
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 mb-2 font-mono">
            {eyebrow}
          </div>
        )}
        <h1 className="text-2xl md:text-4xl font-semibold tracking-tight text-white">
          {title}
        </h1>
        {description && (
          <p className="mt-2 text-sm text-zinc-400 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && (
        <div className="shrink-0 flex items-center gap-2 flex-wrap">{actions}</div>
      )}
    </div>
  );
}
